import { Navigate, type RouteObject } from 'react-router';

import {
  AudiencePage,
  LinksGroupsPage,
  LinksPage,
  RetentionGroupsPage,
  RetentionPage,
} from '@/pages/analytics';
import { PermissionGuard } from '@/app/routers/guards';
import { HistoryTreeWrite } from '@/app/routers/history-store/HistoryTreeWrite';

export const analytics = {
  path: 'analytics',
  children: [
    {
      path: 'retention',
      element: <PermissionGuard permissionKey="retention" />,
      children: [
        {
          index: true,
          element: (
            <HistoryTreeWrite index>
              <RetentionGroupsPage />
            </HistoryTreeWrite>
          ),
        },
        {
          path: ':groupId',
          element: (
            <HistoryTreeWrite>
              <RetentionPage />
            </HistoryTreeWrite>
          ),
        },
      ],
    },
    {
      path: 'links',
      children: [
        {
          index: true,
          element: (
            <HistoryTreeWrite index>
              <LinksGroupsPage />
            </HistoryTreeWrite>
          ),
        },
        {
          path: ':groupId',
          element: (
            <HistoryTreeWrite>
              <LinksPage />
            </HistoryTreeWrite>
          ),
        },
      ],
    },
    {
      path: 'audience',
      element: (
        <PermissionGuard permissionKey="audience">
          <AudiencePage />
        </PermissionGuard>
      ),
    },
    {
      index: true,
      element: <Navigate to="links" />,
    },
    {
      path: '*',
      element: <Navigate to=".." />,
    },
  ],
} satisfies RouteObject;
